import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonModule, Location } from '@angular/common';
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { InputDialog } from "./input-dialog/dialog-input";
import { SettingsService } from "../settings/settings.service";
import { MatTabsModule } from "@angular/material/tabs";
import { CuentasBancarias } from "./ctas/ctas";
import { CreateAccCompanyDialog } from "./ctas/create-ctas/createacc.component";
import { MatButtonModule } from "@angular/material/button";




@Component({
    selector: "app-cuentas-bancarias-component",
    templateUrl: "./cuentas-bancarias.html",
    styleUrls: ["./cuentas-bancarias.less"],
    standalone: true,
    imports: [
      MatDialogModule,
      MatTabsModule,
      CuentasBancarias,
      CreateAccCompanyDialog,
      MatButtonModule,
      CommonModule,

    ]
})
export class CuentasBancariasComponent implements OnInit {

  @Input() id_company: any;
  @Input() token: any;
  @Input() role: any;
  @Input() open_as_dialog:boolean=false;

  @Output() funciones = new EventEmitter<number>();
  companyData!: CompanyDataObject;

  constructor(
    public settings: SettingsService,
    private activeRoute: ActivatedRoute, private change: ChangeDetectorRef, private _location: Location, private dialog:MatDialog) {

    this.activeRoute.params.subscribe((params) => {
      this.id_company = params["id_company"];
    });


    this.role = localStorage.getItem('role');
    this.token = localStorage.getItem('token');

  }


  close() {
    this._location.back();
  }


  async ngOnInit() {
    
    await this.get_company_data();
    await this.load_bancos();
    this.load_cuentas();
    this.guardar_visita();
    this.change.detectChanges();

  }

public doSomething(algo: any): void {
  console.log(algo)
}

  async guardar_visita() {

      try {
        let value = { 'pantalla': 'cuentas-bancarias' }
        const bd: any = await this.settings.get_query(2,  '/visitas-clientes-pantalla/', value);
        var body_data: any = bd._body;
        switch (bd.status) {
          case 201:
          case 200:
            var body_data: any = bd._body;

          break;
          default:

          break;
        }

      } catch (bd:any) {

      }

  }

  actualizar = 0;
  procesaPropagar($e: any) {
    this.actualizar = $e;
  }

  download_planilla: boolean = false;
  disable_download_planilla: boolean = false;
  async download() {
      try {
        this.download_planilla = true;
        this.disable_download_planilla = true;
        const bd: any = await this.settings.get_query(1,'/ConfirmigAcreedoresBank/' + this.id_company + "/");
        var body_data: any = bd._body;
        switch (bd.status) {
          case 201:
          case 200:
              window.open(body_data.nameArchivo, "blank")

           this.download_planilla = false;
           this.disable_download_planilla = false;   

          break;
          default:

          break;
        }

      } catch (bd:any) {
        this.download_planilla = false;
        this.disable_download_planilla = false; 
      }
  }

  @ViewChild('fileBut') fileBut!: ElementRef<HTMLInputElement>;
  upload() {
    this.fileBut.nativeElement.click();
  }

  success: boolean = false;
  warning: boolean = false;
  disabled: boolean = false;
  uploading_file: boolean = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  async upload_file($e: any) {

    this.success = false;
    this.warning = false;
    this.disabled = true;

    let formData: FormData = new FormData();
    let file_input = $e.target.files;

    for (let i = 0; i < file_input.length; i++) {
      let name = file_input[i].name
      formData.append('ctas_' + i, file_input[i], name);
    }

        try {

          this.uploading_file = true;

          const bd: any = await this.settings.get_query(2, '/ConfirmigAcreedoresBank/' + this.id_company + '/', formData);
          var body_data: any = bd._body;
          switch (bd.status) {
            case 201:
            case 200:
                  this.disabled = false;
                  this.uploading_file = false;



                  if (body_data.error.length != 0) {
                    this.warning = true;
                    this.open_input_dialog("¡Atención!", "",
                    "Hay algunos errores en los registros,",
                    "verifique el formato en la Planilla.","fa-triangle-exclamation","#FA454C");
                  } else {
                    this.success = true;
                    this.open_input_dialog("¡Carga exitosa!", "",
                    "Se subio la planilla correctamente",
                    "La información de cuentas bancarias fue actualizada.","fa-circle-check","#4ad991");
                    this.actualizar = 1
                  }





            break;
            default:

            break;
          }

        } catch (bd:any) {
            this.warning = false;
            this.disabled = false;
            this.uploading_file = false;
        }


    this.fileInput.nativeElement.value = '';
  }

  open_input_dialog(title:any,subtitle:any,mensajeprincipal:any, mensajenegrita:any,icon:any,coloricon:any) {
    const dialogRef = this.dialog.open(InputDialog, {
      width: '700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  tabIndex = 0;
  tabChanged(event: any): void {
    this.tabIndex = event.index;
  }

  accountCreatedChangeTab() {
    this.tabIndex = 0;
    this.change.detectChanges();
  }

  async loadDataCompany(companyObject: CompanyDataObject){
    this.companyData = companyObject;
  };


  capitalizeFirstWord(text: string): string {
    if (!text) return ''; // Si es string vacío o null

    return text
      .trim() // elimina espacios al inicio y final
      .toLowerCase() // pone todo en minúsculas
      .replace(/^(\w)(\w*)/, (_, firstLetter, rest) =>
        firstLetter.toUpperCase() + rest
      );
  }


    bancos: Banco[] = [];

  async load_bancos() {
    try {
      const bd: any = await this.settings.get_query(1, '/bank/');
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:
          for (let i = 0; i < body_data.banks.length; i++) {
            this.bancos.push(body_data.banks[i]);
          }

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd, "CAYO EN EL CATCH")
    }
  }

  cuentas: any[] = [];
  loading_cuentas: boolean = true;
  async load_cuentas() {
    try {
      this.loading_cuentas = true;
      this.cuentas = [];
      const bd: any = await this.settings.get_query(1, '/account-type/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
          var body_data: any = bd._body;

          for (let i = 0; i < body_data.accounts.length; i++) {
            if (i != 1) {
              this.cuentas.push(body_data.accounts[i]);
            }
          }

          this.loading_cuentas = false;

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log("AQUI LOAD_CUENTAS", bd);
      this.loading_cuentas = false;
    }
  }

  business_name: string = "";
  rut: any;

    async get_company_data() {
    try {
      const bd: any = await this.settings.get_query(
        1,
        '/company/' + this.id_company + '/'
      );
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
          var body_data: any = bd._body;

          this.rut = body_data.company.rut;
          this.business_name = body_data.company.business_name;
          break;
        default:
          break;
      }
    } catch (bd: any) {}
  }




}

export interface CompanyDataObject {
  businessName: string,
  rut: string
};

interface Banco {
  id: string;
  name: string;
}